import '@actr/utilities/src/polyfills';
// нужно, что бы перед инициализацией приложения проставились конфиги в либу конфигов
import './configs';
import './styles/document.scss';
import './styles/document.css';

import { set } from '@actr/config';
import { reactRootErrorHandlers } from '@actr/logger';
import callWebVitalsLogs from '@actr/widgets/src/logs/web-vitals';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import Layout from 'Root/layout';
import { captureHotelAccessFromUrl } from 'Root/utils/hotel-access';

set({
  app: {
    releaseVersion: import.meta.env.VITE_RELEASE_VERSION,
  }
});

captureHotelAccessFromUrl();

callWebVitalsLogs();

const reactRootOptions = import.meta.env.PROD ? reactRootErrorHandlers : {};

hydrateRoot(document, <Layout />, reactRootOptions);
